<template>
  <v-col cols="12">
    <v-row justify="center">
      <v-col cols="auto">
        <v-img :src="logo" contain width="400" alt="logo" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="6">
<!--        <v-stepper id="stepper" :value="step" alt-labels>-->
<!--          <v-stepper-header>-->
<!--            <template v-for="(item, index) in itemsForProgressBar">-->
<!--              <v-stepper-step-->
<!--                :complete="step > index + 1"-->
<!--                :key="`step-${index}`"-->
<!--                :step="index + 1"-->
<!--              >-->
<!--                <v-img-->
<!--                  width="150"-->
<!--                  class="d-inline margin-right-10"-->
<!--                  contain-->
<!--                  :src="item.image"-->
<!--                ></v-img>-->
<!--              </v-stepper-step>-->
<!--              <v-divider-->
<!--                v-if="index !== itemsForProgressBar.length - 1"-->
<!--                :key="`divider-${index}`"-->
<!--              ></v-divider>-->
<!--            </template>-->
<!--          </v-stepper-header>-->
<!--        </v-stepper>-->
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-slide-x-transition duration="200" mode="out-in">
          <slot-machine
            :key="currentNumber.playType.id"
            ref="slotsMachine"
            :digits="currentNumber.digits"
          >
          </slot-machine>
        </v-slide-x-transition>
      </v-col>
      <v-col cols="12" class="d-flex" align-self="center">
        <v-img
          contain
          height="150"
          width="200"
          id="currentNumberPlayType"
          :src="imageForPlayType(currentNumber.playType)"
          alt="currentNumberPlayType"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import logo from 'assets/static/img/logo/fastpaytv_white.png';
import pick2 from "./images/pick2.png";
import pick3 from "./images/pick3.png";
import pick4 from "./images/pick4.png";
import pick5 from "./images/pick5.png";
import SlotMachine from "./SlotMachine.vue";
import { Howl } from "howler";
// Sounds
import greetingsSrc from "../../../../../assets/static/sounds/superloto/greetings.mp3";
import ResultField from "../../../../enumerations/ResultField.json";
import pickTwoSrc from "../../../../../assets/static/sounds/superloto/pick_two.mp3";
import pickThreeSrc from "../../../../../assets/static/sounds/superloto/pick_three.mp3";
import pickFourSrc from "../../../../../assets/static/sounds/superloto/pick_four.mp3";
import pickFiveSrc from "../../../../../assets/static/sounds/superloto/pick_five.mp3";
import zeroSrc from "../../../../../assets/static/sounds/superloto/zero.mp3";
import oneSrc from "../../../../../assets/static/sounds/superloto/one.mp3";
import twoSrc from "../../../../../assets/static/sounds/superloto/two.mp3";
import threeSrc from "../../../../../assets/static/sounds/superloto/three.mp3";
import fourSrc from "../../../../../assets/static/sounds/superloto/four.mp3";
import fiveSrc from "../../../../../assets/static/sounds/superloto/five.mp3";
import sixSrc from "../../../../../assets/static/sounds/superloto/six.mp3";
import sevenSrc from "../../../../../assets/static/sounds/superloto/seven.mp3";
import eightSrc from "../../../../../assets/static/sounds/superloto/eigth.mp3";
import nineSrc from "../../../../../assets/static/sounds/superloto/nine.mp3";
import sortitionFinishedSrc from "../../../../../assets/static/sounds/superloto/sortition_finished.mp3";

function soundFor(src) {
  return new Howl({
    src,
    volume: 0.5,
    loop: false,
    autoplay: false
  });
}

export default {
  name: "Slots",
  components: {
    SlotMachine
  },
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      logo,
      itemsForProgressBar: [],
      currentNumber: null,
      step: 0,
      greetingsSound: soundFor(greetingsSrc),
      sounds: [
        soundFor(zeroSrc),
        soundFor(oneSrc),
        soundFor(twoSrc),
        soundFor(threeSrc),
        soundFor(fourSrc),
        soundFor(fiveSrc),
        soundFor(sixSrc),
        soundFor(sevenSrc),
        soundFor(eightSrc),
        soundFor(nineSrc)
      ],
      sortitionFinished: soundFor(sortitionFinishedSrc),
      picks: {
        [ResultField.PickTwo]: soundFor(pickTwoSrc),
        [ResultField.CashThree]: soundFor(pickThreeSrc),
        [ResultField.PickFour]: soundFor(pickFourSrc),
        [ResultField.PickFive]: soundFor(pickFiveSrc)
      }
    };
  },
  created() {
    this.itemsForProgressBar = this.result.numbers.map(({ playType }) => {
      return {
        value: playType.id,
        text: playType.name,
        image: this.imageForPlayType(playType)
      };
    });

    this.currentNumber = this.result.numbers[0];
    setTimeout(() => {
      this.start();
    }, 2000);
  },
  methods: {
    async start() {
      this.greetingsSound.play();
      await new Promise(resolve => {
        setTimeout(resolve, 4000);
      });
      for (const number of this.result.numbers) {
        this.step = this.step + 1;
        this.currentNumber = number;
        await this.$nextTick();
        await new Promise(resolve => {
          const waitForSlotMachineTransition = 2000;
          setTimeout(resolve, waitForSlotMachineTransition);
        });
        await new Promise(resolve => {
          this.picks[number.playType.id].play();
          setTimeout(resolve, 1500);
        });
        await this.$refs.slotsMachine.start();
        await new Promise(resolve => {
          const timeoutToStopRoulette = 1000;
          setTimeout(resolve, timeoutToStopRoulette);
        });
        await this.$refs.slotsMachine.stop();
        await new Promise(resolve => {
          const waitForSlotMachineTransition = 1500;
          setTimeout(resolve, waitForSlotMachineTransition);
        });
        for (const d of number.digits.split("")) {
          await new Promise(resolve => {
            this.sounds[parseInt(d, 10)].play();
            setTimeout(resolve, 2000);
          });
        }
        await new Promise(resolve => {
          const timeoutToShowNextRoulette = 2000;
          setTimeout(resolve, timeoutToShowNextRoulette);
        });
      }
      this.$emit("finish");
    },
    imageForPlayType(playType) {
      switch (playType.id) {
        case ResultField.PickTwo:
          return pick2;
        case ResultField.CashThree:
          return pick3;
        case ResultField.PickFour:
          return pick4;
        case ResultField.PickFive:
          return pick5;
      }
    }
  }
};
</script>
<style scoped>
#stepper {
  background-color: transparent;
  box-shadow: none;
}
  .margin-right-10 {
    margin-right: 10px;
  }
</style>
